import { render, staticRenderFns } from "./EventTreatmentDetail.vue?vue&type=template&id=78ce3fe6"
import script from "./EventTreatmentDetail.vue?vue&type=script&lang=js"
export * from "./EventTreatmentDetail.vue?vue&type=script&lang=js"
import style0 from "./EventTreatmentDetail.vue?vue&type=style&index=0&id=78ce3fe6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports